import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
    INPUT_LENGTH_50,
    SWAL_SETTINGS,
} from "../../../../../utils/Constants";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../../utils/customError";
import { VideoCategoryAdd } from "../../../services/video.services";

const AddVideoCategory = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        {
            title: "Video Category",
            url: "/admin/cms/video/category/list/1",
        },
        { title: t("admin.cafes.link_add"), url: "" },
    ];

    const validationSchema = Yup.object().shape({
        category: Yup.string().trim().max(50, "Category must not be more than 50 characters.").required("Category is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            category: "",
        },
        validateOnBlur: false,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("category", values.category);
            VideoCategoryAdd(formData)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        resetForm({ values: "" });
                        navigate(`/admin/cms/video/category/list/1`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        setSubmitted(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div>
                                    <h6 className="main-content-label mb-3">
                                        Add Video Category
                                    </h6>
                                </div>
                                <div className="row row-sm">
                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="category" className="text-left d-flex">
                                            Video Category:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="category"
                                            id="category"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.category}
                                            className="form-control"
                                            placeholder={t("Enter category")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError shortCodes={[INPUT_LENGTH_50]} name="category" form={formik} />
                                        </span>
                                    </div>
                                    {/* <div className="col-lg-12 text-center form-group">
                                        <label htmlFor="subject" className="text-left d-flex">
                                            {t("Description")}:<span className="requirestar">*</span>
                                        </label>
                                        <CustomCkeditor
                                            fieldname={"description"}
                                            setFieldValue={formik.setFieldValue}
                                            value={formik.values.richtext}
                                            setFieldTouched={formik.setFieldTouched}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="description" form={formik} />
                                        </span>
                                    </div> */}
                                    <div className="mt-5">
                                        <button
                                            className="btn btn-info mr-2"
                                            type="submit"
                                            disabled={submitted ? true : null}
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_submit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            disabled={submitted ? true : null}
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("admin.button.btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddVideoCategory;